import { RouteConstants } from "./route-constant";

export type ModuleId = "cdi" | "vbc" | "opcd" | "um" | "caire";

export const getModuleIdFromPath = (pathname: string): ModuleId => {
  if (pathname.startsWith(RouteConstants.ROUTE_VBC_MODULE)) {
    return "vbc";
  }
  if (pathname.startsWith(RouteConstants.ROUTE_OPCD_MODULE)) {
    return "opcd";
  }
  if (pathname.startsWith(RouteConstants.ROUTE_UM_MODULE)) {
    return "um";
  }
  if (pathname.startsWith(RouteConstants.ROUTE_CAIRE_MODULE)) {
    return "caire";
  }
  // CDI owns /cdi plus legacy flat tab paths (dashboard, messages, etc.)
  return "cdi";
};

/** No modules currently use the coming-soon shell. */
export const isComingSoonModule = (_moduleId: ModuleId) => false;
